import React from 'react';

function PasswordField({ name, labelText, required, handleInputChange, handleInputBlur }) {
    return (
        <div className="form-field">
            <label htmlFor={name}>{labelText}</label>
            <input
                id={name}
                name={name}
                type="password"
                required={required}
                onChange={handleInputChange}
                onBlur={handleInputBlur}
            />
        </div>
    );
}

export { PasswordField };
